import React from 'react'
import '../../styles/EmptyTodos.css' 

export default function EmptyTodos() {
  return (
    <p>No hay TODOs</p>
  )
}

export { EmptyTodos }